import styled from 'styled-components';
import { mobileMediaQuery } from '../utils/responsive';
import SideNavigation from './left-menu/SideNavigation';
import ShortcutsModal from './ShortcutsModal';

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: var(--side-panel-width) 1fr;
  grid-template-rows: var(--header-height) 1fr;
  @media ${mobileMediaQuery} {
    grid-template-columns: 1fr;
    grid-template-rows: max-content 0 max-content 1fr;
  }
  width: 100%;
  height: 100%;
`;

const PageComponent = ({ children }) => (
  <PageGrid>
    <SideNavigation />
    <ShortcutsModal />
    {children}
  </PageGrid>
);

export default PageComponent;
